<template>
  <div style="height: 100%">
    <div :class="getClass()">
      <div class="training-filter__arrow-up"></div>

      <div class="training-filter__header">
        <h4>Filters</h4>
      </div>
      <div class="training-filter__body pT0">
        <div><h4>Project Information</h4></div>
        <div class="row">
          <div class="col-md-6" style="padding: 15px">
            <label>Project Title</label><br />
            <ob-select2
              v-if="showProjectOptions"
              v-model.trim="selectedProject"
              :options="projectOptions"
            ></ob-select2>
          </div>
          <div class="col-md-6" style="padding: 15px" v-if="this.from != 'list_view'">
            <label>{{ timesheetLabel }} Cycle</label><br />
            <ob-select2
              v-if="showProjectOptions"
              v-model.trim="selectedTimeCycle"
              :options="timeCycleOptions"
            ></ob-select2>
          </div>
          <div class="col-md-6" style="padding: 15px" v-if="this.from == 'list_view'">
            <label class="col-md-12 p0">{{ timesheetLabel }} Date Range</label>
            <div class="col-md-6 p0">
              <ob-date-time-picker
                style="width: 95%"
                ref="fromDate"
                id="fromDate"
                placeholder="From"
                :inputvalue="FromDate"
                :options="datePickerOptions"
                @updated="(v) => (this.FromDate = v)"
                :dpchange="onFromDateChange"
              ></ob-date-time-picker>
            </div>
            <div class="col-md-6 p0">
              <ob-date-time-picker
                style="width: 95%"
                ref="toDate"
                id="toDate"
                placeholder="To"
                :inputvalue="ToDate"
                :options="datePickerOptions"
                @updated="(v) => (this.ToDate = v)"
              ></ob-date-time-picker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>End-client Name</label>
            <ob-select2
              v-if="showProjectOptions"
              v-model.trim="selectedEndClient"
              :options="endClientOptions"
            ></ob-select2>
          </div>
          <div class="col-md-6">
            <label>Client Name</label>
            <ob-select2
              v-if="showProjectOptions"
              v-model.trim="selectedClient"
              :options="clientNameOptions"
            ></ob-select2>
          </div>
        </div>
        <div style="padding: 11px 0 15px" class="row">
          <div class="col-md-6">
            <label>Project Status</label>
            <br />
            <div class="radio-inline pL0">
              <ob-checkbox name="options3" val="OnGoing" v-model="projectStatus"
                >On-going</ob-checkbox
              >
            </div>
            <div class="radio-inline pL0">
              <ob-checkbox name="options3" val="Completed" v-model="projectStatus"
                >Completed</ob-checkbox
              >
            </div>
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label><br />Timesheet Status</label>
            <br />
            <div class="checkbox-inline pL0" v-if="this.from != 'list_view'">
              <ob-checkbox val="NotSubmitted" v-model="timeSheetStatus"
                >Not Submitted</ob-checkbox
              >
            </div>
            <div class="checkbox-inline pL0" v-if="this.from != 'list_view'">
              <ob-checkbox
                style="padding-left: 10px"
                val="Pending"
                v-model="timeSheetStatus"
                >Pending</ob-checkbox
              >
            </div>
            <div class="checkbox-inline pL0" v-else>
              <ob-checkbox val="Pending" v-model="timeSheetStatus">Pending</ob-checkbox>
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox val="Approved" v-model="timeSheetStatus">Approved</ob-checkbox>
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox val="Rejected" v-model="timeSheetStatus">Rejected</ob-checkbox>
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox val="RequestedForEdit" v-model="timeSheetStatus"
                >Request For Edit</ob-checkbox
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label><br />Expense Status</label>
            <br />
            <div class="checkbox-inline pL0">
              <ob-checkbox val="Pending" v-model="ExpenseStatus">Pending</ob-checkbox>
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox val="Approved" v-model="ExpenseStatus">Approved</ob-checkbox>
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox val="Rejected" v-model="ExpenseStatus">Rejected</ob-checkbox>
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox val="RequestedForEdit" v-model="ExpenseStatus"
                >Request For Edit</ob-checkbox
              >
            </div>
          </div>
        </div>
        <div class="row" v-if="from != 'list_view'">
          <div class="col-md-12">
            <label><br />Invoice Status</label>
            <br />
            <div class="checkbox-inline pL0">
              <ob-checkbox val="Generated" v-model="invoiceStatus">Generated</ob-checkbox>
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox val="NotGenerated" v-model="invoiceStatus">Not Generated</ob-checkbox>
            </div>
          </div>
        </div>
        <div>
          <br />
          <h4>Employment Information</h4>
        </div>
        <div style="padding: 0px 0 15px" class="row">
          <div class="col-md-6">
            <label>Employee Status</label>
            <br />
            <div class="checkbox-inline pL0">
              <ob-checkbox name="options2" val="Active" v-model="employeeStatus"
                >Active</ob-checkbox
              >
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox name="options2" val="Terminated" v-model="employeeStatus"
                >Terminated</ob-checkbox
              >
            </div>
          </div>
          <div class="col-md-6">
            <label>Tax Terms</label>
            <br />
            <div class="checkbox-inline pL0">
              <ob-checkbox val="W2" v-model="TaxTerms">W2</ob-checkbox>
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox val="C2C" v-model="TaxTerms">C2C</ob-checkbox>
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox val="1099" v-model="TaxTerms">1099</ob-checkbox>
            </div>
            <br />
          </div>
        </div>
        <div style="padding: 0px 0 15px" class="row">
          <div class="col-md-6">
            <label>Billing Status</label>
            <br />
            <div class="checkbox-inline pL0">
              <ob-checkbox val="Billing" v-model="billingStatus">Billing</ob-checkbox>
            </div>
            <div class="checkbox-inline pL0">
              <ob-checkbox val="NonBilling" v-model="billingStatus"
                >Non Billing</ob-checkbox
              >
            </div>
          </div>
        </div>
        <div style="padding: 0px 0 15px" class="row">
          <div class="col-md-12">
            <label>Employment Type</label>
            <br />
            <div style="display: flex">
              <div class="checkbox-inline pL0">
                <ob-checkbox val="Full-time" v-model="EmploymentType"
                  >Full-Time</ob-checkbox
                >
              </div>
              <div class="checkbox-inline pL0">
                <ob-checkbox val="Part-time" v-model="EmploymentType"
                  >Part-Time</ob-checkbox
                >
              </div>
              <div class="checkbox-inline pL0">
                <ob-checkbox val="Temporary" v-model="EmploymentType"
                  >Temporary</ob-checkbox
                >
              </div>
              <div class="checkbox-inline pL0">
                <ob-checkbox val="Intern" v-model="EmploymentType">Intern</ob-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row training-filter__footer">
        <ob-button type="secondary" @click="cancelAppliedFilters">Cancel</ob-button>
        <ob-button type="secondary" @click="onClear">Clear</ob-button>
        <ob-button type="primary" @click="applyFilter">Apply</ob-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["from"],
  data() {
    return {
      invoiceStatus:[],
      FromDate: "",
      ToDate: "",
      selectedTimeCycle: "",
      selectedProject: "",
      selectedClient: "",
      selectedEndClient: "",
      // SelectedReportAuth:'',
      showProjectOptions: true,
      showAuthOptions: true,
      timeSheetStatus: [],
      employeeStatus: [],
      billingStatus:[],
      projectStatus: [],
      TaxTerms: [],
      ExpenseStatus: [],
      EmploymentType: [],
      ProjectDetailsList: [],
      projectOptions: {
        placeholder: {
          id: "-1",
          text: "Select Project",
        },
        data: [],
      },
      datePickerOptions: {
        format: "MM/DD/YYYY",
        dayViewHeaderFormat: "MM/DD/YYYY",
        maxDate: moment().add(1, "months"),
        widgetPositioning: {
          horizontal: "auto",
          vertical: "bottom",
        },
      },
      endClientOptions: {
        placeholder: {
          id: "-1",
          text: "Select End Client",
        },
        data: [],
      },
      clientNameOptions: {
        placeholder: {
          id: "-1",
          text: "Select Client",
        },
        data: [],
      },
      timeCycleOptions: {
        placeholder: {
          id: "-1",
          text: `Select ${this.timesheetLabel || 'Timesheet'} Cycle`,
        },
        data: [
          { id: "Weekly", text: "Weekly" },
          { id: "Bi-Weekly", text: "Bi-Weekly" },
          { id: "Semi-Monthly", text: "Semi-Monthly" },
          { id: "Monthly", text: "Monthly" },
          { id: "Custom", text: "Custom" },
        ],
      },
      //   specifyDayOptions:{
      //         placeholder:{
      //             id: '-1',
      //             text: 'Select Date'
      //         },
      //         data: []
      //     },
    };
  },
  watch: {
    selectedProject(val) {
      this.onProjectSelect(val);
    },
    selectedClient(val) {
      this.onClientSelect(val);
    },
    selectedEndClient(val) {
      this.onEndClientSelect(val);
    },
    // selectedTimeCycle(val){
    //     this.onTimeSheetCycleSelect(val)
    // }
  },
  created() {
    this.getProjectRelatedList();
    //this.getReportingAuthList()
  },
  methods: {
    onFromDateChange(e) {
      setTimeout(() => {
        this.$refs.toDate.data.minDate(e.date);
      }, 100);
    },
    getClass() {
      var cls = "training_filter";
      if (this.from == "list_view") {
        cls = "list_filter";
      }
      return cls;
    },
    applyFilter() {
      this.$parent.$parent.filter();
      this.updateFilterValueToStore();

      var jobName =
        this.projectOptions.data.length > 0
          ? this.projectOptions.data.filter((v) => v.id == this.selectedProject)[0]
          : "";
      var clientOrganizationName =
        this.clientNameOptions.data.length > 0
          ? this.clientNameOptions.data.filter((v) => v.id == this.selectedClient)[0]
          : "";
      var endClientOrganizationName =
        this.endClientOptions.data.length > 0
          ? this.endClientOptions.data.filter((v) => v.id == this.selectedEndClient)[0]
          : "";
      // var reportingAuthorityName = this.reportingAuthOptions.data.length > 0  ? this.reportingAuthOptions.data.filter(v=>v.id == this.SelectedReportAuth)[0] : '';

      let Obj = {
        ProjectTitle: jobName,
        ClientName: clientOrganizationName,
        EndClientName: endClientOrganizationName,
        // "ReportingAuthority":reportingAuthorityName,
        TimeSheetStatus: this.timeSheetStatus,
        ExpenseStatus: this.ExpenseStatus,
        FromDate: this.FromDate,
        ToDate: this.ToDate,
        TimeSheetCycle: this.selectedTimeCycle,
        EmployeeStatus: this.employeeStatus,
        BillingStatus:this.billingStatus,
        ProjectStatus: this.projectStatus,
        TaxTerms: this.TaxTerms,
        EmploymentType: this.EmploymentType,
        InvoiceStatus: this.invoiceStatus,
      };
      if (this.from == "list_view") {
        this.$parent.$parent.onApplyFilter(Obj);
      } else {
        events.fire("applyFilter", Obj);
      }
      this.$emit("cancel");
    },
    updateFilterValueToStore() {
      let timeSheetStatus = [];
      this.timeSheetStatus.forEach((f) => {
        timeSheetStatus = this.timeSheetStatus;
      });
      let ExpenseStatus = [];
      this.ExpenseStatus.forEach((f) => {
        ExpenseStatus = this.ExpenseStatus;
      });
      let EmploymentType = [];
      this.EmploymentType.forEach((e) => {
        EmploymentType = this.EmploymentType;
      });
      let TaxTerms = [];
      this.TaxTerms.forEach((f) => {
        TaxTerms = this.TaxTerms;
      });
      let employeeStatus = [];
      this.employeeStatus.forEach((e) => {
        employeeStatus = this.employeeStatus;
      });
      let invoiceStatus = [];
      this.invoiceStatus.forEach((e) => {
        invoiceStatus = this.invoiceStatus;
      });
      let billingStatus=[];
      this.billingStatus.forEach((e)=>{
        billingStatus=this.billingStatus
      })
      let projectStatus = [];
      this.projectStatus.forEach((e) => {
        projectStatus = this.projectStatus;
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "ProjectTitle",
        value: this.selectedProject,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "TimeSheetCycle",
        value: this.selectedTimeCycle,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "ClientName",
        value: this.selectedClient,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "EndClientName",
        value: this.selectedEndClient,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "ReportingAuthority",
        value: this.SelectedReportAuth,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "TimeSheetStatus",
        value: this.timeSheetStatus,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "ExpenseStatus",
        value: this.ExpenseStatus,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "FromDate",
        value: this.FromDate,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "ToDate",
        value: this.ToDate,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "EmployeeStatus",
        value: this.employeeStatus,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
          field: "InvoiceStatus",
          value: this.invoiceStatus,
        });
      this.$store.commit("updateTimeSheetFilterValue",{
        field:"BillingStatus",
        value:this.billingStatus
      })
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "ProjectStatus",
        value: this.projectStatus,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "TaxTerms",
        value: TaxTerms,
      });
      this.$store.commit("updateTimeSheetFilterValue", {
        field: "EmploymentType",
        value: EmploymentType,
      });
    },
    updateFilterValueFromStore() {
      this.showProjectOptions = false;
      this.selectedProject = this.$store.getters.getTimeSheetFilterValue("ProjectTitle");
      this.selectedTimeCycle = this.$store.getters.getTimeSheetFilterValue(
        "TimeSheetCycle"
      );
      this.selectedClient = this.$store.getters.getTimeSheetFilterValue("ClientName");
      this.selectedEndClient = this.$store.getters.getTimeSheetFilterValue(
        "EndClientName"
      );
      this.SelectedReportAuth = this.$store.getters.getTimeSheetFilterValue(
        "ReportingAuthority"
      );
      this.timeSheetStatus = this.$store.getters.getTimeSheetFilterValue(
        "TimeSheetStatus"
      );
      this.ExpenseStatus = this.$store.getters.getTimeSheetFilterValue("ExpenseStatus");
      this.FromDate = this.$store.getters.getTimeSheetFilterValue("FromDate");
      this.ToDate = this.$store.getters.getTimeSheetFilterValue("ToDate");
      this.employeeStatus = this.$store.getters.getTimeSheetFilterValue("EmployeeStatus");
      this.invoiceStatus = this.$store.getters.getTimeSheetFilterValue("InvoiceStatus");
       this.billingStatus=this.$store.getters.getTimeSheetFilterValue("BillingStatus")
      this.projectStatus = this.$store.getters.getTimeSheetFilterValue("ProjectStatus");
      this.TaxTerms = this.$store.getters.getTimeSheetFilterValue("TaxTerms");
      this.EmploymentType = this.$store.getters.getTimeSheetFilterValue("EmploymentType");
      setTimeout(() => {
        this.showProjectOptions = true;
      }, 10);
    },
    onClear() {
      this.employeeStatus = [];
      this.invoiceStatus = [];
      this.billingStatus =[];
      this.projectStatus = [];
      this.selectedProject = "";
      this.selectedTimeCycle = "";
      this.selectedClient = "";
      this.selectedEndClient = "";
      // this.SelectedReportAuth = ''
      this.timeSheetStatus = [];
      this.TaxTerms = [];
      this.EmploymentType = [];
      this.ExpenseStatus = [];
      this.FromDate = "";
      this.ToDate = "";
      this.$store.dispatch("resetTimeSheetFilter");
      setTimeout(() => {
        this.getProjectRelatedList();
        //this.getReportingAuthList()
      }, 100);
    },
    onProjectSelect(value) {
      this.showProjectOptions = false;
      let list = this.ProjectDetailsList.filter((item) => (item.JobId = value));

      let clientList = list.filter((item) => item.ClientOrganizationId != "");

      let uniClientlist = this.getUnique(clientList, "ClientOrganizationId");

      this.clientNameOptions.data = __.map(uniClientlist, (t) => {
        return {
          id: t.ClientOrganizationId,
          text: t.ClientOrganizationName,
        };
      });
      let endCleintList = list.filter((item) => item.EndClientOrganizationName != "");
      let uniEndCleintList = this.getUnique(endCleintList, "EndClientOrganizationName");

      this.endClientOptions.data = __.map(uniEndCleintList, (t) => {
        return {
          id: t.EndClientOrganizationName,
          text: t.EndClientOrganizationName,
        };
      });

      // let timeCycleList = list.filter(item => item.TimeSheetCycle != '');
      // let uniTimeCycleList = this.getUnique(timeCycleList,"TimeSheetCycle")
      // this.timesheetCycleOptions(uniTimeCycleList)

      // this.timeCycleOptions.data = __.map(uniTimeCycleList, (t) => {
      //     return {
      //     'id': t.TimeSheetCycle,
      //     'text': t.TimeSheetCycle
      //     }
      // })
      setTimeout(() => {
        this.showProjectOptions = true;
      }, 1);
    },
    //  onTimeSheetCycleSelect(value){
    //      this.showProjectOptions = false

    //      this.timesheetCycleOptions(this.ProjectDetailsList)
    //      let list = this.ProjectDetailsList.filter(item => item.TimeSheetCycle == value);

    //      let projectSelectList = this.getUnique(list,"JobId")
    //      this.projectOptions.data = __.map(projectSelectList, (t) => {
    //                     return {
    //                     'id': t.JobId,
    //                     'text': t.JobName
    //                     }
    //                 })

    //        let clientList = list.filter(item => item.ClientName != '');

    //               let uniClientlist = this.getUnique(clientList,"ClientName")

    //                this.clientNameOptions.data = __.map(uniClientlist, (t) => {
    //                    return {
    //                     'id': t.ClientName,
    //                     'text': t.ClientOrganizationName
    //                     }
    //                 })
    //                 let endCleintList = list.filter(item => item.EndClientOrganizationName != '');
    //                 let uniEndCleintList = this.getUnique(endCleintList,"EndClientOrganizationName")

    //                 this.endClientOptions.data = __.map(uniEndCleintList, (t) => {
    //                     return {
    //                     'id': t.EndClientOrganizationName,
    //                     'text': t.EndClientOrganizationName
    //                     }
    //                 })

    //                 setTimeout(() => {
    //                     this.showProjectOptions = true;

    //             }, 1)

    //  },
    onClientSelect(value) {
      this.showProjectOptions = false;
      let list = this.ProjectDetailsList.filter(
        (item) => item.ClientOrganizationId == value
      );

      let projectSelectList = this.getUnique(list, "JobId");

      //  let selectedCleintList = this.getUnique(list,value)

      // console.log(" selected client id",selectedCleintList);
      //  console.log(" selected client id",selectedCleintList[0].JobId);

      //  let id = selectedCleintList[0].JobId

      this.projectOptions.data = __.map(projectSelectList, (t) => {
        return {
          id: t.JobId,
          text: t.JobName,
        };
      });

      let endCleintList = list.filter((item) => item.EndClientOrganizationName != "");
      let endCleintOnSelectList = this.getUnique(
        endCleintList,
        "EndClientOrganizationName"
      );

      //let finalList = this.getUnique(endCleintOnSelectList,id)

      // console.log("finallist",finalList);

      this.endClientOptions.data = __.map(endCleintOnSelectList, (t) => {
        return {
          id: t.EndClientOrganizationName,
          text: t.EndClientOrganizationName,
        };
      });

      // let timeCycleList = list.filter(item => item.TimeSheetCycle != '');
      // let uniTimeCycleList = this.getUnique(timeCycleList,"TimeSheetCycle")
      // this.timesheetCycleOptions(uniTimeCycleList)

      // this.timeCycleOptions.data = __.map(uniTimeCycleList, (t) => {
      //     return {
      //     'id': t.TimeSheetCycle,
      //     'text': t.TimeSheetCycle
      //     }
      // })
      setTimeout(() => {
        this.showProjectOptions = true;
      }, 1);
    },
    onEndClientSelect(value) {
      this.showProjectOptions = false;
      let endClientName = this.ProjectDetailsList.filter(
        (item) => item.EndClientOrganizationName == value
      )[0].EndClientOrganizationName;

      let list = this.ProjectDetailsList.filter(
        (item) => item.EndClientOrganizationName == endClientName
      );
      let projectSelectList = this.getUnique(list, "JobId");

      this.projectOptions.data = __.map(projectSelectList, (t) => {
        return {
          id: t.JobId,
          text: t.JobName,
        };
      });
      let clientList = list.filter((item) => item.ClientOrganizationId != "");

      let uniClientlist = this.getUnique(clientList, "ClientOrganizationId");

      this.clientNameOptions.data = __.map(uniClientlist, (t) => {
        return {
          id: t.ClientOrganizationId,
          text: t.ClientOrganizationName,
        };
      });
      //    let timeCycleList = list.filter(item => item.TimeSheetCycle != '');
      //                 let uniTimeCycleList = this.getUnique(timeCycleList,"TimeSheetCycle")
      //                 this.timesheetCycleOptions(uniTimeCycleList)

      //                 this.timeCycleOptions.data = __.map(uniTimeCycleList, (t) => {
      //                     return {
      //                     'id': t.TimeSheetCycle,
      //                     'text': t.TimeSheetCycle
      //                     }
      //                 })
      setTimeout(() => {
        this.showProjectOptions = true;
      }, 1);
    },
    cancelAppliedFilters() {
      this.$emit("cancel");
    },
    getUnique(arr, comp) {
      const unique = arr
        .map((e) => e[comp])

        // store the keys of the unique objects
        .map((e, i, final) => final.indexOf(e) === i && i)

        // eliminate the dead keys & store unique objects
        .filter((e) => arr[e])
        .map((e) => arr[e]);
      return unique;
    },
    // timesheetCycleOptions(list){
    //      list.filter(item => {
    //                 if(item.TimeSheetCycle == 'SemiMonthly'){
    //                     item.TimeSheetCycle = 'Semi-Monthly'
    //                 }
    //                 if(item.TimeSheetCycle == 'BiWeekly'){
    //                      item.TimeSheetCycle = 'Bi-Weekly'
    //                 }
    //             });
    // },
    getProjectRelatedList() {
      this.showProjectOptions = false;
      this.$loading({ loadingText: "Please wait..." });
      ajax.get(
        `/TimeSheets/ProjectDetails?orgId=${this.loggedInUserObj.orgId}`,
        {},
        (res) => {
          if (res.data.State == true) {
            this.ProjectDetailsList = res.data.ProjectDetails;

            let projectsList = this.getUnique(this.ProjectDetailsList, "JobId");
            this.projectOptions.data = __.map(projectsList, (t) => {
              return {
                id: t.JobId,
                text: t.JobName,
              };
            });
            // let timeSheetCycleList = this.getUnique(this.ProjectDetailsList,"TimeSheetCycle")
            // this.timesheetCycleOptions(timeSheetCycleList)
            // this.timeCycleOptions.data =  __.map( timeSheetCycleList, (t) => {
            //     return {
            //     'id': t.TimeSheetCycle,
            //     'text': t.TimeSheetCycle
            //     }
            // })

            let clientList = this.ProjectDetailsList.filter(
              (item) => item.ClientOrganizationId != ""
            );
            let uniClientlist = this.getUnique(clientList, "ClientOrganizationId");
            this.clientNameOptions.data = __.map(uniClientlist, (t) => {
              return {
                id: t.ClientOrganizationId,
                text: t.ClientOrganizationName,
              };
            });
            let endClientlist = this.getUnique(
              this.ProjectDetailsList,
              "EndClientOrganizationName"
            );
            let p = endClientlist.filter((item) => item.EndClientOrganizationName != "");
            this.endClientOptions.data = __.map(p, (t, i) => {
              return {
                id: t.EndClientOrganizationName,
                text: t.EndClientOrganizationName,
              };
            });
          }
          this.updateFilterValueFromStore();
          // this.showProjectOptions = true
          this.$loading({}).close();
        }
      );
    },
    //  getReportingAuthList(){
    //    this.showAuthOptions = false;
    //     this.$loading({loadingText: 'Please wait...'});
    //     ajax.get(`/Supervisor/ReportingAuthorityList`, {}, (res) => {
    //         if(res.data.State == true){
    //         let reportAuthLsit = res.data.ReportingAuthorities
    //             this.reportingAuthOptions.data = __.map(reportAuthLsit, (t) => {
    //                 return {
    //                 'id': t.ReportingAuthorityId,
    //                 'text': t.Name
    //                 }
    //             })
    //         }
    //         this.showAuthOptions = true
    //         //this.$loading({}).close()
    //      })
    //     },
  },
};
</script>
<style lang="scss" scoped>
@import "~styles/framework/bootstrap/variables";
.list_filter {
  background: $ob-white-color;
  position: relative;
  border: 1px solid $ob-light-gray-1;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  -moz-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  box-shadow: 0 2px 4px 0 $ob-filter-grey;
  position: absolute;
  width: 40%;
  top: 18%;
  left: 27%;
  z-index: 4;
  &:after,
  &:before {
    bottom: 100%;
    left: 34%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:before {
    border-color: transparent;
    border-bottom-color: $ob-light-gray-1;
    border-width: 13px;
    margin-left: -13px;
  }
  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: $ob-white-color;
    border-width: 12px;
    margin-left: -12px;
  }
  p {
    margin-bottom: 0;
  }
  h4 {
    color: $ob-brand-primary;
  }
  .training-filter__header {
    border-bottom: 1px solid $ob-light-gray-1;
    padding: 10px;
  }
  .training-filter__body {
    background: $ob-white-color;
    padding: 15px;
    max-height: 354px;
    overflow-x: auto;
    overflow-y: auto;
    .form-group {
      label {
        display: inline-block;
        max-width: 100%;
        margin-bottom: 5px;
        font-weight: 400;
      }
    }
  }
  .training-filter__footer {
    text-align: center;
    background: $ob-white-color;
    margin: 0;
    border-top: 1px solid $ob-light-gray-1;
    padding: 10px;
    button {
      margin: 0 5px;
    }
  }
}

.training_filter {
  background: $ob-white-color;
  position: relative;
  border: 1px solid $ob-light-gray-1;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  -moz-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  box-shadow: 0 2px 4px 0 $ob-filter-grey;
  position: absolute;
  width: 42%;
  // top: 65px;
  // left: 296px;
  top: 19%;
  left: 25.6%;
  z-index: 4;
  &:after,
  &:before {
    bottom: 100%;
    left: 37%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:before {
    border-color: transparent;
    border-bottom-color: $ob-light-gray-1;
    border-width: 13px;
    margin-left: -13px;
  }
  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: $ob-white-color;
    border-width: 12px;
    margin-left: -12px;
  }
  p {
    margin-bottom: 0;
  }
  h4 {
    color: $ob-brand-primary;
  }
  .training-filter__header {
    border-bottom: 1px solid $ob-light-gray-1;
    padding: 10px;
  }
  .training-filter__body {
    background: $ob-white-color;
    padding: 15px;
    max-height: 354px;
    overflow-y: auto;
    overflow-x: auto;
    .form-group {
      label {
        display: inline-block;
        max-width: 100%;
        margin-bottom: 5px;
        font-weight: 400;
      }
    }
  }
  .training-filter__footer {
    text-align: center;
    background: $ob-white-color;
    margin: 0;
    border-top: 1px solid $ob-light-gray-1;
    padding: 10px;
    button {
      margin: 0 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/TimeSheetsFilter.vue